import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import SharedFavoritesProvider from '../sharedComponents/SharedFavoritesProvider';
import { ShoppingWithTile } from './ShoppingWithTile';
import { ShoppingWithQuote } from './ShoppingWithQuote';
import styles from './styles/ShoppingWithGrid.scss';

class ShoppingWithGridComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeQuickView: null,
        };
        this.handleCloseQuickView = this.handleCloseQuickView.bind(this);
        this.handleOpenQuickView = this.handleOpenQuickView.bind(this);
    }
    handleOpenQuickView(index) {
        this.setState({ activeQuickView: index });
    }
    handleCloseQuickView() {
        this.setState({ activeQuickView: null });
    }
    render() {
        const { shoppingWith, viewer, isClient, relayEnvironment, userId } = this.props;
        const favoritesProviderProps = {
            disable: !isClient,
            userId,
            environment: relayEnvironment,
            itemIds: (shoppingWith.items || []).map(item => item.serviceId),
            fetchFavorites: !!userId,
            viewer: viewer || null,
        };

        return (
            <CurrencyProvider
                render={({ currency }) => (
                    <div className={styles.wrapper}>
                        <BarHeader
                            htmlElementType="h2"
                            title={
                                <FormattedMessage
                                    id="ShoppingWithGrid.title"
                                    defaultMessage="Top Picks"
                                />
                            }
                            subtitle={
                                <FormattedMessage
                                    id="ShoppingWithGrid.subTitle"
                                    defaultMessage="Discover {name}'s favorite pieces"
                                    values={{ name: shoppingWith.title }}
                                />
                            }
                        />
                        <div className={styles.gridWrapper}>
                            <SharedFavoritesProvider {...favoritesProviderProps}>
                                {({ favorites }) => {
                                    const items = shoppingWith.items || [];
                                    const results = [];
                                    for (let i = 0; i < items.length; i++) {
                                        const item = items[i];
                                        // if there's a quote in the cms, put it in position
                                        // 9 in the grid.
                                        if (i === 8 && shoppingWith.quote) {
                                            results.push(
                                                <div
                                                    className={`${styles.tileWrapper} ${styles.isQuote}`}
                                                    key="quote"
                                                >
                                                    <ShoppingWithQuote
                                                        shoppingWith={shoppingWith}
                                                    />
                                                </div>
                                            );
                                        }
                                        results.push(
                                            <div
                                                className={styles.tileWrapper}
                                                key={item.serviceId}
                                            >
                                                <ShoppingWithTile
                                                    openQuickView={this.handleOpenQuickView}
                                                    closeQuickView={this.handleCloseQuickView}
                                                    activeQuickView={this.state.activeQuickView}
                                                    currency={currency}
                                                    hasUserId={!!userId}
                                                    index={i}
                                                    item={item}
                                                    isClient={isClient}
                                                    {...favorites}
                                                />
                                            </div>
                                        );
                                    }
                                    return results;
                                }}
                            </SharedFavoritesProvider>
                        </div>
                    </div>
                )}
            />
        );
    }
}

ShoppingWithGridComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    shoppingWith: PropTypes.object.isRequired,
    relayEnvironment: PropTypes.object.isRequired,
    isClient: PropTypes.bool.isRequired,
    userId: PropTypes.string,
};

export const ShoppingWithGrid = createFragmentContainer(ShoppingWithGridComponent, {
    shoppingWith: graphql`
        fragment ShoppingWithGrid_shoppingWith on ShoppingWith {
            title
            quote {
                __typename
            }
            items {
                serviceId
                ...ShoppingWithTile_item
            }
            ...ShoppingWithQuote_shoppingWith
        }
    `,
    viewer: graphql`
        fragment ShoppingWithGrid_viewer on Viewer {
            ...SharedFavoritesProvider_viewer
        }
    `,
});
